import { render, staticRenderFns } from "./ButtonDownloadPhoto.vue?vue&type=template&id=77f5ad4f"
import script from "./ButtonDownloadPhoto.vue?vue&type=script&lang=js"
export * from "./ButtonDownloadPhoto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports